import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { Page, TransitionUrl, TranslationPath } from '../../../contexts/kioskConfiguration/type';
import useLanguage from '../../../contexts/language/LanguageContext';
import { getTranslationByPath } from '../../../utils/translations';
import { Footer } from '../../../layout/footer/Footer';
import { MainContent } from '../../../layout/content/MainContent';
import { setSelectedPage } from '../../../store/slices/app/appSlice';


type Block = {
  type: 'text' | 'image' | 'space' | 'block'
  image?: string
  translation?: TranslationPath
  height?: string
  width?: string
  blocks?: Block[]
  center?: boolean
  verticalCenter?: boolean
}

export type UniversalTemplateType = {
  transitionUrl: TransitionUrl
  center: boolean
  direction: 'column' | 'row'
  blocks: Block[]
}

type Props = {
  page: Page<UniversalTemplateType>
}

type BlockProps = {
  block: Block
}

const BlockImage = (props: BlockProps): ReactElement => {
  return <img src={`${process.env.APP_DATA_LINK + props.block.image}`} alt=""/>
}

const BlockText = (props: BlockProps): ReactElement => {
  const language = useLanguage()
  return <span dangerouslySetInnerHTML={{ __html: getTranslationByPath(language.translations, props.block.translation ?? '') }}/>
}

const BlockSpace = (props: BlockProps): ReactElement => {
  return <div style={{ height: props.block.height, width: props.block.width }} />
}

export const Blocks = ({ blocks }: { blocks: Block[] }): React.ReactElement => {
  return <>
    {blocks.map(((row, index) => {
      return (
        <div key={index.toString()} className="flex">
          {row.type === 'text' && (
            <BlockText block={row} />
          )}
          {row.type === 'image' && (
            <BlockImage block={row} />
          )}
          {row.type === 'space' && (
            <BlockSpace block={row} />
          )}
          {row.type === 'block' && row.blocks && (
            <div
              className={`flex flex-row ${row.center ? 'justify-center' : ''} ${row.verticalCenter ? 'items-center' : ''} w-full`}>
              <Blocks blocks={row.blocks}/>
            </div>
          )}
        </div>
      )
    }))}
  </>
}

export const UniversalTemplate = (props: Props): React.ReactElement => {
  const dispatch = useDispatch()

  return <div>
    <MainContent>
      <div className={`flex ${props.page.data.center ? 'items-center' : ''} ${props.page.data.direction === 'row' ? 'flex-row' : 'flex-col'}`}>
        <Blocks blocks={props.page.data.blocks} /> 
      </div>
    </MainContent>

    <Footer
      backUrl={props.page.footer?.back}
      onContinue={() => {
        dispatch(setSelectedPage(props.page.data.transitionUrl))
      }}
    />

  </div>
}
